import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { FieldsInput } from "../../../../components";
import Layout from "../../../../styles/Layout.styles";

const TeamsName = (props) => {
  const { name, validationMessage } = props;
  const style = Style();
  const layout = Layout();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={mergeClasses(layout.w_100, layout.mb_15)}>
        <FieldsInput
          label={t("team_name")}
          placeholder={t("enter_team_name")}
          fieldClassName="custom-label"
          validationMessage={
            validationMessage ? validationMessage : props.errors?.name?.message
          }
          id="name"
          name="name"
          inputDefaultValue={name}
          inputClassName={mergeClasses(style.textboxInput, layout.w_100)}
          validation={props.register("name", {
            required: `${t("validation_message.team_name_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default TeamsName;
